import React from "react";
import classNames from "classnames";
import { VisualIcon } from "../../Components";

import classes from "./CheckIcon.module.scss";

export interface CheckIconProps extends React.HTMLAttributes<HTMLDivElement> {}

const CheckIcon: React.FC<CheckIconProps> = ({ className, ...props }) => (
   <VisualIcon className={classNames(classes.icon, className)} {...props}>
      <svg
         xmlns="http://www.w3.org/2000/svg"
         width="50"
         height="50"
         viewBox="0 0 50 50"
         fill="none"
      >
         <path
            d="M41.6667 12.5L18.75 35.4167L8.33337 25"
            stroke="white"
            strokeWidth="8"
            strokeLinecap="round"
            strokeLinejoin="round"
         />
      </svg>
   </VisualIcon>
);

export default CheckIcon;
